"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _isEqual = _interopRequireDefault(require("lodash/isEqual"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _get = _interopRequireDefault(require("lodash/get"));

var _cloneDeep = _interopRequireDefault(require("lodash/cloneDeep"));

var _map = _interopRequireDefault(require("lodash/map"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _attributeSelector = require("@cimpress-technology/attribute-selector");

var _Loading = _interopRequireDefault(require("./Loading"));

var _AttributesAggregator = _interopRequireDefault(require("./AttributesAggregator"));

var _services = require("./services");

var _commonUtils = require("./commonUtils");

var _customQuantities = require("./customQuantities");

var _Pricing = require("./Modules/Pricing");

var _PivotingController = _interopRequireDefault(require("./PivotingController"));

var _ruleSetInfo = require("./ruleSetInfo");

var _productCategory = require("./productCategory");

var _constants = _interopRequireDefault(require("./constants"));

var cancelableRuleSetPromise;
var requiredAttributesWithValues = [];

var PriceAttributesAggregatorByRuleSet =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2["default"])(PriceAttributesAggregatorByRuleSet, _PureComponent);

  function PriceAttributesAggregatorByRuleSet(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, PriceAttributesAggregatorByRuleSet);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(PriceAttributesAggregatorByRuleSet).call(this, props));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "DEFAULT_QUANTITY_CONFIG", [true, false, false, false]);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "CATEGORY_DISPLAY_NAMES", ['Product', 'Sub-Category', 'Category', 'All Categories']);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "categoriesPerSku", {});
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "setInitialAttributeSelections", function (options) {
      if (Array.isArray(options)) {
        var optionKeys = options.map(function (option) {
          return option.key.toLowerCase();
        });

        var initialAttributeSelections = _this.props.initialAttributeSelections.filter(function (attribute) {
          return optionKeys.includes(attribute.key.toLowerCase());
        });

        _this.setState({
          initialAttributeSelections: initialAttributeSelections
        });
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "initializeOptions", function (inputs, sku, ruleSet) {
      var quantityConfigOptions = _this.state.quantityConfigOptions;
      var options = _this.state.options;
      var initialAttributeSelections = _this.props.initialAttributeSelections;

      if (!options) {
        var ruleSetInfo = (0, _ruleSetInfo.getRuleSetInfo)(ruleSet, inputs);
        options = Object.values(ruleSetInfo.allAttributeValues).map(function (option) {
          option.label = (0, _services.capitalize)(option.key);
          option.value = option.key;
          option.selectedValues = option.selectedValues || option.defaults || option.values;
          return option;
        });
        var quantityAttribute = options.find(function (option) {
          return option.label.toLowerCase() === 'quantity';
        });
        var initialQuantityAttribute = initialAttributeSelections && initialAttributeSelections.find(function (attribute) {
          return attribute.key.toLowerCase() === 'quantity';
        });
        var initialQuantity = initialQuantityAttribute && parseInt(initialQuantityAttribute.resolvedValue, 10);

        _this.setInitialAttributeSelections(options);

        var promises = [];
        promises.push(_this.getCustomQuantities(sku, quantityAttribute).then(function (quantities) {
          if (!(0, _services.isEmptyArray)(quantities) && quantityAttribute) {
            if (initialQuantity && !quantities.includes(initialQuantity)) {
              quantities = [initialQuantity].concat((0, _toConsumableArray2["default"])(quantities));
            }

            quantityAttribute.selectedValues = quantities;
          }
        }));

        if (!quantityConfigOptions) {
          promises.push(_this.getCategoryIds(sku).then(function () {
            return _this.getQuantityConfigOptions();
          }));
        }

        Promise.all(promises).then(function () {
          _this.setState({
            options: options,
            isPivotingLoaded: true,
            isLoading: false
          });
        });
      } else {
        _this.setState({
          isPivotingLoaded: true,
          isLoading: false
        });
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onChangePivotResponse", function (pivotResponse) {
      var resolvedAttributes = [];

      if (pivotResponse) {
        var pivotKeys = _this.getPivotKeys();

        var pivotKey = Object.keys(pivotResponse)[0];
        Object.entries(pivotResponse[pivotKey]).forEach(function (_ref) {
          var _ref2 = (0, _slicedToArray2["default"])(_ref, 2),
              pivotValue = _ref2[0],
              attributes = _ref2[1];

          if (pivotKeys.length === 1) {
            resolvedAttributes.push({
              key: "".concat(pivotKey, "|").concat(pivotValue),
              values: [attributes]
            });
          } else if (pivotKeys.length === 2) {
            var values = [];
            Object.entries(attributes).forEach(function (_ref3) {
              var _ref4 = (0, _slicedToArray2["default"])(_ref3, 2),
                  pivotKeyB = _ref4[0],
                  pivotBValues = _ref4[1];

              if (pivotBValues && !pivotBValues.length) {
                Object.entries(pivotBValues).forEach(function (_ref5) {
                  var _ref6 = (0, _slicedToArray2["default"])(_ref5, 2),
                      bKey = _ref6[0],
                      bValue = _ref6[1];

                  bValue.key = "".concat(pivotKeyB, "|").concat(bKey);
                  values.push(bValue);
                });
              }
            });
            resolvedAttributes.push({
              key: "".concat(pivotKey, "|").concat(pivotValue),
              values: values
            });
          }
        });
      }

      if (!pivotResponse) {
        return;
      }

      _this.onPartiallyResolved(resolvedAttributes, _this.fetchDisplayedAttributes(resolvedAttributes));
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onChange", function (_ref7) {
      var state = _ref7.state,
          attributes = _ref7.attributes;
      var displayedAttributes = {};

      if (!attributes) {
        return;
      }

      var filtered = attributes.filter(function (each) {
        return each.isDisplayed;
      });

      for (var each = 0; each < filtered.length; each += 1) {
        displayedAttributes[filtered[each].key] = filtered[each].resolvedValue !== undefined ? filtered[each].resolvedValue : null;
      }

      if (state === _attributeSelector.ProductState.partiallyResolved || state === _attributeSelector.ProductState.fullyResolved) {
        var resolvedAttributes;
        var quantityAttribute = attributes.find(function (item) {
          return item.key.toLowerCase() === 'quantity';
        });

        if (quantityAttribute) {
          var key = quantityAttribute.key,
              resolvedValue = quantityAttribute.resolvedValue;
          resolvedAttributes = [{
            key: "".concat(key, "|").concat(resolvedValue),
            values: [{
              state: state,
              attributes: attributes.filter(function (attribute) {
                return attribute.resolvedValue;
              })
            }]
          }];
        }

        _this.onPartiallyResolved(resolvedAttributes, displayedAttributes);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onFamilyAttributesSelectorChange", function (_ref8) {
      var attributes = _ref8.attributes;
      var mcpSku = attributes.find(function (attribute) {
        return attribute.key === _constants["default"].MCPSKU;
      });

      if (mcpSku && mcpSku.resolvedValue && _this.state.sku !== mcpSku.resolvedValue) {
        _this.setState({
          selectedSkuInFamily: mcpSku.resolvedValue,
          sku: mcpSku.resolvedValue
        }, function () {
          return _this.initializeData(mcpSku.resolvedValue);
        });
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onUnresolvable", function (violations, displayedAttributes) {
      _this.props.onUnresolvable(violations, (0, _cloneDeep["default"])(requiredAttributesWithValues), displayedAttributes);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onSkuChange", function (value) {
      _this.setState({
        selectedSkuInFamily: value
      }, function () {
        return _this.initializeData(value);
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "checkAndCallBackToFullyResolved", function (requiredAttributes, resolvedAttributesList, displayedAttributes, onPartiallyResolvedCallBack, onFullyResolvedCallBack) {
      var isArray = Array.isArray(resolvedAttributesList) && resolvedAttributesList.length;
      var fullyResolved = isArray && resolvedAttributesList.find(function (_ref9) {
        var values = _ref9.values;
        return values && values.find(function (item) {
          return (0, _commonUtils.areKeysSame)(item.state, _constants["default"].FULLY_RESOLVED);
        });
      });
      var unresolvable = isArray && resolvedAttributesList.find(function (_ref10) {
        var values = _ref10.values;
        return values && values.find(function (item) {
          return (0, _commonUtils.areKeysSame)(item.state, _constants["default"].UNRESOLVABLE);
        });
      });

      if (!fullyResolved && !unresolvable) {
        if (isArray) {
          onPartiallyResolvedCallBack(resolvedAttributesList, requiredAttributes, displayedAttributes);
        }
      } else {
        onFullyResolvedCallBack(resolvedAttributesList, requiredAttributes, displayedAttributes);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onPartiallyResolved", function (resolvedAttributes, displayedAttributes) {
      var requiredAttributes = _this.state.requiredAttributes;
      var sku = _this.state.sku; // If removing mcpsku directly from the drop down then calling reset

      if (sku && Object.prototype.hasOwnProperty.call(displayedAttributes, 'McpSku') && !displayedAttributes.McpSku) {
        _this.resetSelector();
      } else if (displayedAttributes.McpSku && // checking selected sku is not the previous one, if not then only calling initializeData method to get new data
      displayedAttributes.McpSku !== sku) {
        // Initializing (getting required attributes) data after getting sku
        _this.initializeData(displayedAttributes.McpSku);
      } else if (requiredAttributes) {
        // Checking required attributes are fully resolved or not
        _this.checkAndCallBackToFullyResolved(requiredAttributes, resolvedAttributes, displayedAttributes, _this.props.onPartiallyResolved, _this.props.onFullyResolved);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onAttributeSelectorReset", function () {
      _this.resetSelector();

      _this.props.onReset();
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onError", function (error) {
      _this.setState({
        error: error.message
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getInputs", function (sku) {
      var _this$props = _this.props,
          authToken = _this$props.authToken,
          customRequiredAttributes = _this$props.customRequiredAttributes,
          ruleSet = _this$props.ruleSet;

      if (!(0, _isEmpty["default"])(customRequiredAttributes)) {
        return _this.setRequiredAttributesInState(customRequiredAttributes, sku, ruleSet);
      } // Making a service call to get required inputs


      cancelableRuleSetPromise = (0, _services.makeCancelable)(Promise.all([(0, _services.getInputs)(sku, authToken), (0, _services.getRuleSet)(sku, authToken)]));
      return cancelableRuleSetPromise.promise.then(function (response) {
        if (response) {
          var _response = (0, _slicedToArray2["default"])(response, 2),
              result = _response[0],
              ruleSetsRes = _response[1];

          var ruleSetResponse = ruleSetsRes ? (0, _commonUtils.getAuthoritativeRuleSet)(ruleSetsRes) : {};

          _this.setRequiredAttributesInState(result.inputs, sku, ruleSetResponse);

          _this.initializeOptions(result.inputs, sku, ruleSetResponse);
        }
      })["catch"](function (e) {
        var error = e.toString();

        _this.setState({
          error: error,
          isLoading: false
        });
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "setRequiredAttributesInState", function (inputs, sku, ruleSet) {
      var _this$props2 = _this.props,
          hideDerivedAttributes = _this$props2.hideDerivedAttributes,
          pivotConfiguration = _this$props2.pivotConfiguration;
      var requiredAttributesModelEntity = (0, _commonUtils.getRequiredAttributes)(inputs, sku, [], ruleSet);
      var requiredAttributes = requiredAttributesModelEntity.requiredAttributesEntity,
          requiredAttributesWithValuesModel = requiredAttributesModelEntity.requiredAttributesWithValuesModel;

      var _ref11 = hideDerivedAttributes ? (0, _commonUtils.getDerivedAttributes)(ruleSet, requiredAttributes) : [],
          derivedAttributes = _ref11.derivedAttributes,
          attributeToShowList = _ref11.attributeToShowList;

      requiredAttributesWithValues = requiredAttributesWithValuesModel;
      var error = null;

      if (requiredAttributes && !requiredAttributes.length) {
        error = _constants["default"].MSG_NO_REQ_ATTRIBUTE_ERROR;

        _this.props.onError();
      }

      _this.setState({
        sku: sku,
        requiredAttributes: requiredAttributes,
        error: error,
        derivedAttributes: derivedAttributes,
        attributeToShowList: attributeToShowList
      }); // Setting all the product and non product attributes


      if (pivotConfiguration) {
        pivotConfiguration.forEach(function (pivotAttribute) {
          if (!requiredAttributesWithValues.find(function (requiredAttribute) {
            return (0, _commonUtils.areKeysSame)(requiredAttribute.key, pivotAttribute.key);
          })) {
            requiredAttributesWithValues.push({
              key: pivotAttribute.key,
              resolvedValue: null,
              "class": pivotAttribute["class"]
            });
          }
        });
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getPivotKeys", function () {
      var _this$props3 = _this.props,
          pivotConfiguration = _this$props3.pivotConfiguration,
          isPivot = _this$props3.isPivot;
      var attributeKeys = [];

      if (isPivot) {
        attributeKeys = (0, _cloneDeep["default"])(pivotConfiguration);
      } else {
        attributeKeys.push('Quantity');
      }

      return attributeKeys;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "fetchDisplayedAttributes", function (resolvedAttributes) {
      var displayedAttributes = {};
      var attributes = (0, _get["default"])(resolvedAttributes, '[0].values[0].attributes');

      if (attributes) {
        var filtered = attributes.filter(function (each) {
          return each.isDisplayed;
        });

        for (var i = 0; i < filtered.length; i++) {
          displayedAttributes[filtered[i].key] = filtered[i].resolvedValue !== undefined ? filtered[i].resolvedValue : null;
        }
      }

      return displayedAttributes;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updatePivotAttributes", function (pivotConfiguration) {
      if (_this.ref.current) {
        _this.ref.current.updatePivotAttributes(pivotConfiguration);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "prepareFinalResolvedAttributes", function (resolvedAttributes) {
      var clonedRequiredAttributesWithValues = (0, _cloneDeep["default"])(requiredAttributesWithValues);

      if (!resolvedAttributes) {
        return {
          clonedRequiredAttributesWithValues: clonedRequiredAttributesWithValues,
          pivotResolvedAttributes: []
        };
      }

      return {
        clonedRequiredAttributesWithValues: clonedRequiredAttributesWithValues,
        pivotResolvedAttributes: resolvedAttributes
      };
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "resetSelector", function () {
      if (_this.state.familyHasSingleSku) {
        _this.setState({
          initialAttributeSelections: []
        });
      } else {
        _this.setState({
          requiredAttributes: null,
          initialAttributeSelections: [],
          sku: null,
          selectedSkuInFamily: null
        }); // If skus are multiple then setting mcp sku as null in requiredAttributesWithValues, otherwise it can cause of callback to fully resolved if there are no products attributes


        var mcpSkuAttribute = (0, _commonUtils.getRefOfRequiredAttribute)(requiredAttributesWithValues, _constants["default"].MCPSKU, _constants["default"].PRODUCT);

        if (mcpSkuAttribute) {
          mcpSkuAttribute.attributeValue = null;
        }
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "init", function () {
      var _this$props4 = _this.props,
          ruleSet = _this$props4.ruleSet,
          customRequiredAttributes = _this$props4.customRequiredAttributes;

      _this.setState({
        selectedSkuInFamily: null
      });

      requiredAttributesWithValues = []; // If there is no rule set then populate ui with custom required attributes

      if ((0, _isEmpty["default"])(ruleSet) && !(0, _isEmpty["default"])(customRequiredAttributes)) {
        _this.initializeData(null);

        return;
      } // Getting and checking the ruleSet because it can have a single sku only


      var skuReferenceId = (0, _commonUtils.getSkuFromRuleSet)(ruleSet);

      if (skuReferenceId) {
        // If sku id is new then only call initializeData method to get new required input param
        if (_this.state.sku !== skuReferenceId) {
          _this.initializeData(skuReferenceId);
        } else {
          _this.setState({
            isLoading: false
          });
        }
      } else {
        _this.setState({
          isLoading: false,
          familyHasSingleSku: false
        });
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "showErrorInfoModal", function () {
      var _this$state = _this.state,
          requiredAttributes = _this$state.requiredAttributes,
          familyHasSingleSku = _this$state.familyHasSingleSku,
          pivotConfiguration = _this$state.pivotConfiguration;
      var showErrorModal = _this.props.showErrorModal;
      var numberOfPivotAttributes = pivotConfiguration && pivotConfiguration.length;

      if (showErrorModal && familyHasSingleSku && // Initial value of `requiredAttributes` is null so we need to check this only if it is not null so can't use `isEmpty`.
      requiredAttributes && // if length is 0 that's mean there is no attributes for this product
      requiredAttributes.length - numberOfPivotAttributes < 1) {
        return (0, _commonUtils.getNotificationAlert)(_constants["default"].MSG_NO_REQ_ATTRIBUTE, 'info');
      }

      return null;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getQuantityConfiguration",
    /*#__PURE__*/
    (0, _asyncToGenerator2["default"])(
    /*#__PURE__*/
    _regenerator["default"].mark(function _callee() {
      var quantityConfig;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              quantityConfig = _this.state.quantityConfig;

              if (quantityConfig) {
                _context.next = 9;
                break;
              }

              _context.next = 4;
              return (0, _customQuantities.getQuantityConfiguration)(_this.props.authToken);

            case 4:
              _context.t0 = _context.sent;

              if (_context.t0) {
                _context.next = 7;
                break;
              }

              _context.t0 = _this.DEFAULT_QUANTITY_CONFIG;

            case 7:
              quantityConfig = _context.t0;

              _this.setState({
                quantityConfig: quantityConfig
              });

            case 9:
              return _context.abrupt("return", quantityConfig);

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getCategoryIds",
    /*#__PURE__*/
    function () {
      var _ref13 = (0, _asyncToGenerator2["default"])(
      /*#__PURE__*/
      _regenerator["default"].mark(function _callee2(sku) {
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(0, _services.isEmptyArray)(_this.categoriesPerSku[sku])) {
                  _context2.next = 4;
                  break;
                }

                _context2.next = 3;
                return (0, _productCategory.getProductCategories)(sku, _this.props.authToken);

              case 3:
                _this.categoriesPerSku[sku] = _context2.sent;

              case 4:
                return _context2.abrupt("return", !(0, _services.isEmptyArray)(_this.categoriesPerSku[sku]) ? _this.categoriesPerSku[sku].map(function (category) {
                  return category.categoryId;
                }) : null);

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x) {
        return _ref13.apply(this, arguments);
      };
    }());
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getQuantityConfigOptions",
    /*#__PURE__*/
    (0, _asyncToGenerator2["default"])(
    /*#__PURE__*/
    _regenerator["default"].mark(function _callee3() {
      var _this$state2, quantityConfigOptions, quantityConfig, sku, categories, skip, i, index, category, description, content;

      return _regenerator["default"].wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _this$state2 = _this.state, quantityConfigOptions = _this$state2.quantityConfigOptions, quantityConfig = _this$state2.quantityConfig;
              sku = _this.state.sku;

              if (!(0, _services.isEmptyArray)(quantityConfig)) {
                _context3.next = 6;
                break;
              }

              _context3.next = 5;
              return _this.getQuantityConfiguration();

            case 5:
              quantityConfig = _context3.sent;

            case 6:
              categories = _this.categoriesPerSku[sku];

              if (!categories) {
                _context3.next = 12;
                break;
              }

              skip = 4 - categories.length;
              quantityConfigOptions = [];

              if (!(0, _services.isEmptyArray)(categories) && !(0, _services.isEmptyArray)(quantityConfig)) {
                for (i = 0; i < categories.length; i++) {
                  index = i > 0 ? skip + i : i;
                  category = categories[i];
                  index = category.categoryId === _constants["default"].CATALOG_ROOT ? 3 : index;
                  description = category.description ? " (".concat(category.description, " ").concat(category.name, ")") : null;
                  content = _react["default"].createElement("span", {
                    className: "quantity-config-options",
                    key: "quantity-config-options"
                  }, _react["default"].createElement("span", {
                    className: "heading",
                    key: "heading"
                  }, _this.CATEGORY_DISPLAY_NAMES[index]), _react["default"].createElement("span", {
                    className: "description",
                    key: "description"
                  }, description));
                  quantityConfigOptions.push({
                    content: content,
                    value: category.categoryId,
                    checked: quantityConfig[index]
                  });
                }

                _this.setState({
                  quantityConfigOptions: quantityConfigOptions
                });
              }

              return _context3.abrupt("return", quantityConfigOptions);

            case 12:
              return _context3.abrupt("return", undefined);

            case 13:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    })));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getCustomQuantities",
    /*#__PURE__*/
    function () {
      var _ref15 = (0, _asyncToGenerator2["default"])(
      /*#__PURE__*/
      _regenerator["default"].mark(function _callee4(sku, quantityAttribute) {
        var authToken, options, categoryIds, customQuantitiesForAllCategories, closestCategoryBreaks;
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                authToken = _this.props.authToken;
                options = _this.state.options;
                _context4.next = 4;
                return _this.getCategoryIds(sku);

              case 4:
                categoryIds = _context4.sent;
                _context4.next = 7;
                return (0, _customQuantities.getCustomQuantitiesForMultipleKeys)(categoryIds, authToken);

              case 7:
                customQuantitiesForAllCategories = _context4.sent;
                closestCategoryBreaks = customQuantitiesForAllCategories ? customQuantitiesForAllCategories.find(function (breaks) {
                  return !(0, _services.isEmptyArray)(breaks);
                }) : [];
                quantityAttribute = quantityAttribute || options && options.find(function (item) {
                  return item.label.toLowerCase() === 'quantity';
                });

                if (!(0, _services.isEmptyArray)(closestCategoryBreaks)) {
                  closestCategoryBreaks = closestCategoryBreaks.filter(function (quantity) {
                    return (0, _services.validateInputForAttribute)(quantity, quantityAttribute);
                  });
                }

                return _context4.abrupt("return", (0, _services.isEmptyArray)(closestCategoryBreaks) ? (0, _services.getValues)(quantityAttribute) : closestCategoryBreaks);

              case 12:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      return function (_x2, _x3) {
        return _ref15.apply(this, arguments);
      };
    }());
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "setSelectedValuesInOptions",
    /*#__PURE__*/
    function () {
      var _ref16 = (0, _asyncToGenerator2["default"])(
      /*#__PURE__*/
      _regenerator["default"].mark(function _callee5(label, values) {
        var options, match;
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                options = _this.state.options;

                if (!(0, _services.isEmptyArray)(options) && !(0, _services.isEmptyArray)(values)) {
                  match = options.find(function (option) {
                    return option.label.toLowerCase() === label.toLowerCase();
                  });

                  if (match) {
                    match.selectedValues = values;
                  }
                }

                _this.props.updatePivotValues(label, values);

              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      return function (_x4, _x5) {
        return _ref16.apply(this, arguments);
      };
    }());
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "saveCustomQuantities",
    /*#__PURE__*/
    function () {
      var _ref17 = (0, _asyncToGenerator2["default"])(
      /*#__PURE__*/
      _regenerator["default"].mark(function _callee6(quantities) {
        var authToken, sku, categoryIds, quantityConfig, checkedCategories, skip, i, index;
        return _regenerator["default"].wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                // this.setSelectedValuesInOptions('quantity', quantities);
                authToken = _this.props.authToken;
                sku = _this.state.sku;
                _context6.prev = 2;
                _context6.next = 5;
                return _this.getCategoryIds(sku);

              case 5:
                categoryIds = _context6.sent;
                _context6.next = 8;
                return _this.getQuantityConfiguration();

              case 8:
                quantityConfig = _context6.sent;
                checkedCategories = [];

                if (!(0, _services.isEmptyArray)(categoryIds) && !(0, _services.isEmptyArray)(quantityConfig)) {
                  skip = 4 - categoryIds.length;

                  for (i = 0; i < categoryIds.length; i++) {
                    index = i > 0 ? skip + i : i;

                    if (quantityConfig[index]) {
                      checkedCategories.push(categoryIds[i]);
                    }
                  }
                }

                (0, _customQuantities.setCustomQuantitiesForMultipleKeys)(checkedCategories, quantities, authToken);
                _context6.next = 16;
                break;

              case 14:
                _context6.prev = 14;
                _context6.t0 = _context6["catch"](2);

              case 16:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, null, [[2, 14]]);
      }));

      return function (_x6) {
        return _ref17.apply(this, arguments);
      };
    }());
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "saveQuantityConfig", function (inputQuantityConfig, quantities) {
      _this.saveCustomQuantities(quantities);

      var quantityConfig = _this.state.quantityConfig;
      var skip = 4 - inputQuantityConfig.length;

      for (var i = 0; i < inputQuantityConfig.length; i++) {
        var index = i > 0 ? skip + i : i;
        quantityConfig[index] = inputQuantityConfig[i];
      }

      (0, _customQuantities.setQuantityConfiguration)(quantityConfig, _this.props.authToken);

      _this.setState({
        quantityConfig: quantityConfig
      }, _this.getQuantityConfigOptions);
    });
    _this.ref = _react["default"].createRef();
    _this.state = PriceAttributesAggregatorByRuleSet.getInitialState(_this.props);
    return _this;
  }

  (0, _createClass2["default"])(PriceAttributesAggregatorByRuleSet, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setState({
        pivotConfiguration: this.props.pivotConfiguration
      });
      this.init();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this2 = this;

      if (!(0, _isEqual["default"])(prevProps.initialAttributeSelections, this.props.initialAttributeSelections)) {
        this.setInitialAttributeSelections(this.state.options);
      }

      if (!(0, _isEqual["default"])(prevProps.ruleSet, this.props.ruleSet) || !(0, _isEqual["default"])(prevProps.initialAttributeSelections, this.props.initialAttributeSelections) || !(0, _isEqual["default"])(prevProps.attributeConfigurations, this.props.attributeConfigurations) || !(0, _isEqual["default"])(prevProps.customRequiredAttributes, this.props.customRequiredAttributes) || !(0, _isEqual["default"])(prevProps.hiddenAttributes, this.props.hiddenAttributes) || prevProps.hideDerivedAttributes !== this.props.hideDerivedAttributes || !(0, _isEqual["default"])(prevProps.isPivot, this.props.isPivot) || prevProps.authToken !== this.props.authToken) {
        if (!(0, _isEqual["default"])(prevProps.ruleSet, this.props.ruleSet)) {
          this.setState({
            options: undefined
          }, function () {
            cancelableRuleSetPromise.cancel();

            _this2.init();
          });
        } else {
          this.init();
        }
      }

      if (prevProps.isPivot !== this.props.isPivot || !(0, _isEqual["default"])(prevProps.pivotConfiguration, this.props.pivotConfiguration)) {
        if (this.props.isPivot === true) {
          this.setState({
            pivotConfiguration: this.props.pivotConfiguration
          });
        } else {
          this.setState({
            pivotConfiguration: []
          });
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      (0, _commonUtils.cancelPromise)(cancelableRuleSetPromise);
    }
  }, {
    key: "initializeData",
    value: function initializeData(sku) {
      var _this3 = this;

      this.setState({
        isLoading: true
      }, function () {
        return _this3.getInputs(sku);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state3 = this.state,
          error = _this$state3.error,
          requiredAttributes = _this$state3.requiredAttributes,
          sku = _this$state3.sku,
          options = _this$state3.options,
          initialAttributeSelections = _this$state3.initialAttributeSelections,
          isLoading = _this$state3.isLoading,
          derivedAttributes = _this$state3.derivedAttributes,
          selectedSkuInFamily = _this$state3.selectedSkuInFamily,
          pivotConfiguration = _this$state3.pivotConfiguration,
          attributeToShowList = _this$state3.attributeToShowList,
          quantityConfigOptions = _this$state3.quantityConfigOptions,
          isPivotingLoaded = _this$state3.isPivotingLoaded;
      var _this$props5 = this.props,
          showErrorModal = _this$props5.showErrorModal,
          ruleSet = _this$props5.ruleSet,
          hiddenAttributes = _this$props5.hiddenAttributes,
          showAttributeSelectorErrorModal = _this$props5.showAttributeSelectorErrorModal,
          customRequiredAttributes = _this$props5.customRequiredAttributes,
          authToken = _this$props5.authToken,
          isPivot = _this$props5.isPivot,
          showSelectorPivotUI = _this$props5.showSelectorPivotUI,
          consumerType = _this$props5.consumerType,
          attributeConfigurations = _this$props5.attributeConfigurations,
          onRowSelectionChange = _this$props5.onRowSelectionChange,
          onColumnSelectionChange = _this$props5.onColumnSelectionChange,
          selectedRow = _this$props5.selectedRow,
          selectedColumn = _this$props5.selectedColumn,
          expanded = _this$props5.expanded,
          toggleExpanded = _this$props5.toggleExpanded,
          showPivotConfig = _this$props5.showPivotConfig;

      if (isLoading) {
        return _react["default"].createElement(_Loading["default"], null);
      }

      if (error && consumerType !== _constants["default"].ATTRIBUTESELECTORPRICING) {
        return showErrorModal ? (0, _commonUtils.getNotificationAlert)(error, 'danger') : null;
      }

      var reqAttributesMsgModal = this.showErrorInfoModal();
      var ruleSetWithNonProductAttributes = (0, _commonUtils.addNonProductAttributesInRuleSet)(ruleSet, requiredAttributes);
      var customRuleSet = null;

      if ((0, _isEmpty["default"])(ruleSet) && !(0, _isEmpty["default"])(customRequiredAttributes)) {
        var emptyRuleSet = {
          whiteList: [],
          rules: []
        };
        customRuleSet = _Pricing.Pricing.updateRuleSet(emptyRuleSet, customRequiredAttributes);
      }

      var familyWithSkuAndRuleSet = {
        ruleSet: !(0, _isEmpty["default"])(ruleSetWithNonProductAttributes) ? ruleSetWithNonProductAttributes : customRuleSet,
        sku: sku || null
      };
      var hiddenAttributesKeys = null;
      var filteredAttributeKeys = null;

      if (!isLoading) {
        // Filtering attributes key from dervied attributes if user don't want to see them on UI.
        // Its controlled by flag `hideDerivedAttributes` but even if value of this flag is `false` state `derivedAttributes` will be empty
        // so no check is required here.
        filteredAttributeKeys = (0, _commonUtils.getFilteredProductAttributeKeys)(requiredAttributes, derivedAttributes);
        filteredAttributeKeys = filteredAttributeKeys.concat(attributeToShowList);
        hiddenAttributesKeys = (0, _map["default"])(hiddenAttributes, function (hiddenAttribute) {
          return hiddenAttribute.attributeKey;
        });
      }

      return _react["default"].createElement(_react["default"].Fragment, null, this.state.options && isLoading ? null : _react["default"].createElement("div", {
        className: "innerContainer"
      }, !isPivotingLoaded ? null : _react["default"].createElement(_PivotingController["default"], {
        sku: sku,
        authToken: authToken,
        options: options,
        selectedRow: selectedRow,
        selectedColumn: selectedColumn,
        onRowSelectionChange: onRowSelectionChange,
        onColumnSelectionChange: onColumnSelectionChange,
        expanded: expanded,
        toggleExpanded: toggleExpanded,
        setSelectedValuesInOptions: this.setSelectedValuesInOptions,
        quantityConfigOptions: quantityConfigOptions,
        saveQuantityConfig: this.saveQuantityConfig,
        showPivotConfig: showPivotConfig
      }), _react["default"].createElement("div", {
        className: reqAttributesMsgModal ? 'hide-aggregator' : ''
      }, _react["default"].createElement(_AttributesAggregator["default"], {
        authToken: authToken,
        family: familyWithSkuAndRuleSet,
        productAttributeKeys: filteredAttributeKeys,
        onChange: this.onChange,
        onFamilyAttributesSelectorChange: this.onFamilyAttributesSelectorChange,
        onReset: this.onAttributeSelectorReset,
        initialAttributeSelections: initialAttributeSelections,
        hiddenAttributes: hiddenAttributesKeys,
        showErrorModal: showAttributeSelectorErrorModal,
        onSkuChange: this.onSkuChange,
        selectedSkuInFamily: selectedSkuInFamily,
        skuChangeState: this.state.skuChangeState,
        pivotConfiguration: pivotConfiguration,
        isPivot: isPivot,
        onChangePivotResponse: this.onChangePivotResponse,
        showSelectorPivotUI: showSelectorPivotUI,
        ref: this.ref,
        onError: this.onError,
        consumerType: consumerType,
        attributeConfigurations: attributeConfigurations
      }))), reqAttributesMsgModal);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (!(0, _isEqual["default"])(nextProps.ruleSet, prevState.ruleSet) || !(0, _isEqual["default"])(nextProps.customRequiredAttributes, prevState.customRequiredAttributes) || !(0, _isEqual["default"])(nextProps.hiddenAttributes, prevState.hiddenAttributes) || nextProps.hideDerivedAttributes !== prevState.hideDerivedAttributes || nextProps.authToken !== prevState.authToken) {
        return PriceAttributesAggregatorByRuleSet.getInitialState(nextProps);
      }

      return prevState;
    }
  }]);
  return PriceAttributesAggregatorByRuleSet;
}(_react.PureComponent);

exports["default"] = PriceAttributesAggregatorByRuleSet;
(0, _defineProperty2["default"])(PriceAttributesAggregatorByRuleSet, "propTypes", {
  authToken: _propTypes["default"].string.isRequired,
  ruleSet: _propTypes["default"].shape({}),
  onFullyResolved: _propTypes["default"].func,
  onPartiallyResolved: _propTypes["default"].func,
  onUnresolvable: _propTypes["default"].func,
  onReset: _propTypes["default"].func,
  initialAttributeSelections: _propTypes["default"].arrayOf(_propTypes["default"].shape({})),
  attributeConfigurations: _propTypes["default"].shape({}),
  customRequiredAttributes: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    scope: _propTypes["default"].string.isRequired,
    name: _propTypes["default"].string.isRequired
  })),
  hiddenAttributes: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    "class": _propTypes["default"].string.isRequired,
    attributeKey: _propTypes["default"].string.isRequired,
    isForceShowIfDerivingAttributes: _propTypes["default"].bool
  })),
  showErrorModal: _propTypes["default"].bool,
  showAttributeSelectorErrorModal: _propTypes["default"].bool,
  hideDerivedAttributes: _propTypes["default"].bool,
  isPivot: _propTypes["default"].bool.isRequired,
  pivotConfiguration: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    key: _propTypes["default"].string.isRequired
  })),
  showSelectorPivotUI: _propTypes["default"].bool.isRequired,
  consumerType: _propTypes["default"].string,
  onRowSelectionChange: _propTypes["default"].func.isRequired,
  onColumnSelectionChange: _propTypes["default"].func.isRequired,
  selectedRow: _propTypes["default"].shape({}),
  selectedColumn: _propTypes["default"].shape({}),
  expanded: _propTypes["default"].bool.isRequired,
  toggleExpanded: _propTypes["default"].func.isRequired,
  showPivotConfig: _propTypes["default"].bool.isRequired,
  updatePivotValues: _propTypes["default"].func.isRequired,
  onError: _propTypes["default"].func.isRequired
});
(0, _defineProperty2["default"])(PriceAttributesAggregatorByRuleSet, "defaultProps", {
  onUnresolvable: function onUnresolvable() {},
  onPartiallyResolved: function onPartiallyResolved() {},
  onFullyResolved: function onFullyResolved() {},
  onReset: function onReset() {},
  ruleSet: null,
  initialAttributeSelections: [],
  attributeConfigurations: {},
  customRequiredAttributes: [],
  hiddenAttributes: [],
  showErrorModal: true,
  showAttributeSelectorErrorModal: false,
  hideDerivedAttributes: true,
  pivotConfiguration: []
});
(0, _defineProperty2["default"])(PriceAttributesAggregatorByRuleSet, "getInitialState", function (props) {
  return {
    sku: null,
    authToken: props.authToken,
    ruleSet: props.ruleSet,
    familyHasSingleSku: true,
    isLoading: true,
    isPivotingLoaded: false,
    requiredAttributes: null,
    customRequiredAttributes: props.customRequiredAttributes,
    // this state is used only in 'getDerivedStateFromProps' method to re-initialize state.
    hiddenAttributes: props.hiddenAttributes,
    // this state is used only in 'getDerivedStateFromProps' method to re-initialize state.
    derivedAttributes: [],
    hideDerivedAttributes: props.hideDerivedAttributes,
    // this state is used only in 'getDerivedStateFromProps' method to re-initialize state.
    error: null
  };
});